import overArg from './_overArg.js';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

export default nativeKeys;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_nativeKeys.js
// module id = 1481
// module chunks = 1